import { ComponentProps } from "react"
import { Icon, IconProps, Tooltip } from "@oysterhr/ui"

type CommonProps = Omit<ComponentProps<typeof Tooltip>, "children"> & {
  /**
   * The className to be passed to the icon component
   */
  className?: string

  iconTestId?: string
}

type IconWithTooltipProps = {
  icon?: IconProps["name"]
  size?: IconProps["size"]
} & CommonProps

export const IconWithTooltip = (props: IconWithTooltipProps) => {
  const { className, iconTestId, onClick, ...rest } = props
  return (
    <Tooltip {...rest}>
      <span data-testid={iconTestId}>
        <Icon
          name={props.icon || "InfoCircle"}
          size={props.size || "sm"}
          onClick={onClick}
          className={className || "text-primary-base hover:text-primary-darken-100"}
        />
      </span>
    </Tooltip>
  )
}
